import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Message, Segment, Menu, Container, Sidebar } from "semantic-ui-react";

import Header from "components/Header";
import { TermCalculator } from "components/views/widgets";
import { Widget } from "components/views/widgets/Widget";

import {
  Contracts,
  Dashboard,
  Marketing,
  Profile,
  Salespeople,
  Systems,
} from "../views";

const NoMatch = () => (
  <Container>
    <Segment>
      <Message
        negative
        icon="exclamation"
        size="huge"
        header="404"
        content="Not Found"
      />
    </Segment>
  </Container>
);

const Unverified = () => (
  <Container>
    <Segment>
      <Message
        warning
        icon="exclamation"
        size="huge"
        header="Your account is unverified"
        content="Your access to this portal is limited"
      />
    </Segment>
  </Container>
);

const LoggedInContainer = (props) => {
  const { verified } = props;

  return (
    <Router>
      <Sidebar.Pushable as={Segment} className="app-container">
        <Sidebar
          as={Menu}
          direction={window.innerWidth <= 1024 ? "top" : "left"}
          vertical={window.innerWidth <= 1024 ? false : true}
          visible
        >
          <Header onLogout={props.onLogout} verified={verified} />
        </Sidebar>
        <div className="widgets">
          <Widget
            title="Term Calculator"
            width={1050}
            icon="calculator"
            color="pink"
          >
            <TermCalculator />
          </Widget>
        </div>
        <Sidebar.Pusher>
          <div className="ui container view-container">
            <Switch>
              <Route path="/dealer/profile" component={Profile} />
              <Route
                exact
                path="/dealer/"
                render={() => <Dashboard verified={verified} />}
              />
              {verified && (
                <React.Fragment>
                  <Route
                    path="/dealer/contracts"
                    render={(renderProps) =>
                      verified ? (
                        <Contracts
                          {...renderProps}
                          isFinancial={props.isFinancial}
                        />
                      ) : (
                        <Unverified />
                      )
                    }
                  />
                  <Route path="/dealer/marketing" component={Marketing} />
                  <Route
                    path="/dealer/salespeople"
                    component={verified ? Salespeople : Unverified}
                  />
                  <Route
                    path="/dealer/systems"
                    component={verified ? Systems : Unverified}
                  />
                </React.Fragment>
              )}
              <Route component={NoMatch} />
            </Switch>
          </div>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    </Router>
  );
};

export default LoggedInContainer;
